import { styled } from "styled-components";

/**
 * 소통(건의/문의) 처리 상태 배지.
 *
 * 목록(처리여부 컬럼)과 답변 상세 페이지에서 공통으로 쓴다. 이전에는 상태별
 * PNG(AnswerNot/AnswerContinue/AnswerFinish, AnswerWaiting/Continue/End)를
 * 따로 관리했으나, 텍스트로 굽힌 이미지라 흐릿하고 색/문구 수정이 불가능해
 * 텍스트 배지로 통일했다.
 *
 * @param {"waiting"|"inProgress"|"done"} type 상태 키
 */
const BADGE_BY_TYPE = {
  waiting: { label: "답변대기", bg: "#9aa0a6" },
  inProgress: { label: "진행 중", bg: "#f5a623" },
  done: { label: "답변완료", bg: "#0b5a9c" },
};

export function CommunicationStatusBadge({ type, className }) {
  const badge = BADGE_BY_TYPE[type] ?? BADGE_BY_TYPE.done;
  return (
    <Badge $bg={badge.bg} className={className}>
      {badge.label}
    </Badge>
  );
}

export default CommunicationStatusBadge;

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 72px;
  height: 30px;
  padding: 0 14px;
  border-radius: 15px;
  background-color: ${({ $bg }) => $bg};
  color: #ffffff;
  font-family: "Noto Sans KR";
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
`;
